import addHeaderTags from './addHeaderTags'
import importStyles from './importStyles'
import getInfoFromURL from './getInfoFromURL'
import handleInitError from './handleInitError'
import bootstrapApps from './bootstrapApps'
import setupTracking from './setupTracking'
import * as UrlBuilder from './urlBuilder'

import events from '@/shared/events'
const siteBrandKeys = {
  zava: 'zava',
  sd: 'superdrug',
  dred: 'dred',
  tosca: 'tosca'
}

export default function () {
  // get information from Url
  const [urlPrefix, serviceId, , , headers] = getInfoFromURL()
  const baseUrl = UrlBuilder.getBaseUrl(urlPrefix)

  const url = `${baseUrl}/api/v2/assessment/${serviceId}`

  fetch(url, { headers })
    .then((response) => response.json())
    .then(async (response) => {
      if (window.newrelic && !response.site) {
        window.newrelic.noticeError(new Error('fetchAndSetSiteInfo.js: Missing country from response'))
      }
      if (!response.site) throw new Error(response.message)
      // set global variable for later use with variables for current Site
      window.siteInfo = response.site

      // translate site keys to design system friendly brand keys
      window.siteInfo.brand = siteBrandKeys[window.siteInfo.site]

      // Remove site info key from response
      delete response.site

      // Set global variable for later use with variables for current Service
      window.serviceDetails = response

      // Max filesize for image uploads
      window.maxFileSize = 8388608

      return { siteInfo: window.siteInfo, ...window.serviceDetails }
    })
    .then(addHeaderTags)
    .then(importStyles)
    .then(() => {
      events.dispatch('site-info:ready')
    })
    .then(setupTracking)
    .then(bootstrapApps)
    .catch(handleInitError)
}
